import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import ODDS from './odds-button.palette-schema.yaml';

registerTileSchema(ODDS);

export function generateOddsButton(TILE) {
    const ODDS_TEXT_BASE = {
        textTransform: 'none', // Fix mojito weird default styles
    };

    return {
        view: {
            infoText: {
                style: {
                    ...ODDS_TEXT_BASE,
                    ...TILE.ODDS_INFO_TEXT,
                    fontSize: TILE.ODDS_PRICE_TEXT.fontSize, // Same as price text
                },
            },
            infoTextOverrides: {
                vertical: {...ODDS_TEXT_BASE, ...TILE.ODDS_INFO_TEXT, lineHeight: '16px'},
                active: TILE.ODDS_SELECTED_INFO_TEXT,
            },
            priceTextEllipsis: {
                style: {
                    lineHeight: ODDS_TEXT_BASE.lineHeight,
                },
            },
            priceText: {
                base: ODDS_TEXT_BASE,
                active: TILE.ODDS_SELECTED_PRICE_TEXT,
                inactive: TILE.ODDS_PRICE_TEXT,
            },
            unavailable: {
                ...ODDS_TEXT_BASE,
                ...TILE.ODDS_UNAVAILABLE_TEXT,
            },
            borderStyle:
                TILE.ODDS_BORDER_COLOR !== 'transparent'
                    ? {
                          borderStyle: 'solid',
                          borderWidth: 1,
                          borderColor: TILE.ODDS_BORDER_COLOR,
                          borderRadius: TILE.ODDS_BORDER_RADIUS,
                      }
                    : {borderStyle: 'none'},

            background: {
                _mobile_inactivehover: TILE.ODDS_BG,
                _mobile_activehover: TILE.ODDS_SELECTED_BG,
                inactive: TILE.ODDS_BG,
                active: TILE.ODDS_SELECTED_BG,
                inactivehover: TILE.ODDS_HOVER_BG,
                activehover: TILE.ODDS_SELECTED_HOVER_BG,
                disabled: TILE.ODDS_DISABLED_BG,
            },
            lockedIcon: icon(TILE.ODDS_LOCKED_ICON_COLOR, TILE.ODDS_LOCKED_ICON_SRC),
            priceChangeIndicators: {
                arrowheadDown: {
                    style: {
                        backgroundColor: TILE.ODDS_PRICE_INDICATOR_DOWN_COLOR,
                    },
                },
                arrowheadUp: {
                    style: {
                        backgroundColor: TILE.ODDS_PRICE_INDICATOR_UP_COLOR,
                    },
                },
            },
        },
    };
}
